var map = {
	"./avatar-oliver-base-full.png": 17463,
	"./avatar-oliver-fall-full.png": 46083,
	"./avatar-oliver-spring-full.png": 62611,
	"./avatar-oliver-summer-full.png": 9619,
	"./avatar-oliver-travel-full.png": 14898,
	"./avatar-oliver-winter-full.png": 57743
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76214;